<div class="landing-container">
    <!-- Header Section -->
    <div class="header-section">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-md-8">
                    <h1 class="display-4 fw-bold text-primary">SchucoGate</h1>
                    <p class="lead">Your comprehensive platform for managing articles, systems, and rules in BPSolver
                    </p>
                </div>
                <div class="col-md-4 text-end">
                    <div *ngIf="!loggedIn" class="auth-section">
                        <button class="btn btn-outline-primary btn-lg me-2" (click)="login()">
                            <i class="bi bi-box-arrow-in-right"></i> Login
                        </button>
                    </div>
                    <div *ngIf="loggedIn" class="auth-section">
                        <span class="welcome-back-text me-3">Welcome back!</span>
                        <button class="btn btn-landing-logout" (click)="logout()">
                            <i class="bi bi-box-arrow-right me-1"></i> Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Main Content -->
    <div class="main-content">
        <div class="container">
            <!-- Welcome Message -->
            <div class="row mb-5" *ngIf="!loggedIn">
                <div class="col-12 text-center">
                    <div class="alert alert-info" role="alert">
                        <h4 class="alert-heading">
                            <i class="bi bi-info-circle"></i> Welcome to SchucoGate
                        </h4>
                        <p>Please log in to access all features and manage your articles, systems, and rules.</p>
                        <hr>
                        <button class="btn btn-primary" (click)="login()">
                            <i class="bi bi-box-arrow-in-right"></i> Get Started - Login Now
                        </button>
                    </div>
                </div>
            </div>

            <!-- Available Routes Section -->
            <div class="row">
                <div class="col-12">
                    <h2 class="section-title">
                        <i class="bi bi-grid-3x3-gap"></i>
                        {{loggedIn ? 'Available Features' : 'Available Public Features'}}
                    </h2>
                    <p class="section-description">
                        {{loggedIn ? 'Access all the tools and features available in SchucoGate' : 'Some features
                        require authentication to access'}}
                    </p>
                </div>
            </div>

            <!-- Routes Grid -->
            <div class="row g-4">
                <div class="col-lg-4 col-md-6" *ngFor="let route of getAvailableRoutes()">
                    <div class="card route-card h-100" (click)="navigateToRoute(route.path)">
                        <div class="card-body">
                            <div class="d-flex align-items-center mb-3">
                                <div class="route-icon">
                                    <i [class]="'bi ' + route.icon"></i>
                                </div>
                                <h5 class="card-title mb-0 ms-3">{{route.title}}</h5>
                            </div>
                            <p class="card-text text-muted">{{route.description}}</p>
                            <div class="card-footer bg-transparent border-0 p-0 mt-auto">
                                <button class="btn btn-primary w-100">
                                    <i class="bi bi-arrow-right"></i> Access {{route.title}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Login Prompt for Protected Routes -->
            <div class="row mt-5" *ngIf="!loggedIn && hasProtectedRoutes()">
                <div class="col-12">
                    <div class="card border-warning">
                        <div class="card-body text-center">
                            <h4 class="card-title text-warning">
                                <i class="bi bi-lock"></i> More Features Available
                            </h4>
                            <p class="card-text">
                                Additional features are available after logging in, including:
                            </p>
                            <ul class="list-unstyled">
                                <li *ngFor="let route of getProtectedRoutes()">
                                    <i class="bi bi-check-circle text-success me-2"></i>{{route.title}}
                                </li>
                            </ul>
                            <button class="btn btn-warning btn-lg mt-3" (click)="login()">
                                <i class="bi bi-box-arrow-in-right"></i> Login to Access All Features
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Empty State -->
            <div class="row mt-5" *ngIf="getAvailableRoutes().length === 0">
                <div class="col-12 text-center">
                    <div class="alert alert-warning" role="alert">
                        <h4 class="alert-heading">
                            <i class="bi bi-exclamation-triangle"></i> No Routes Available
                        </h4>
                        <p>There are currently no routes configured or available for your access level.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer -->
    <footer class="footer-section">
        <div class="container">
            <div class="row">
                <div class="col-12 text-center">
                    <p class="text-muted mb-0">
                        <i class="bi bi-shield-check"></i>
                        SchucoGate - Secure Article & System Management Platform
                    </p>
                </div>
            </div>
        </div>
    </footer>
</div>